export const MarketColorDotVariant = {
  Default: 'DEFAULT',
  Bordered: 'BORDERED',
} as const;
export type MarketColorDotVariant = (typeof MarketColorDotVariant)[keyof typeof MarketColorDotVariant];

export type MarketColorDotProps = {
  market: string;
  variant?: MarketColorDotVariant;
  borderColor?: string;
};
